import { Button, List, ListItem, Popover, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { type FC, useEffect, useState } from 'react';

const StyledButton = styled(Button)(
  ({ theme }) => `
    background-color: ${theme.colors.avani.turc};
    border-radius: 8px;
    border: none;
    color: white;
    padding: 8px 12px;

    &:hover {
      border: none;
      color: ${theme.colors.avani.darkTitleText};

      .MuiSvgIcon-root {
        color: ${theme.colors.avani.darkTitleText};
      }
    }
`
);

const StyledListItem = styled(ListItem)(
  () => `
  cursor: pointer;
  display: flex;

  svg {
    margin-right: 12px;
  }
`
);

interface IProps {
  barNames: string[];
  setBarName: (val: string | undefined) => void;
}
export const ResultsByTapBarDropdown: FC<IProps> = ({ barNames, setBarName }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const [buttonLabel, setButtonLabel] = useState<string>();

  useEffect(() => {
    if (barNames.length === 1) {
      setBarName(barNames[0]);
      setButtonLabel(barNames[0]);
    } else setButtonLabel('All Bars');
    //todo:v2-changes
  }, []);

  return (
    <>
      <StyledButton
        variant="outlined"
        disabled={!barNames.length}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          backgroundColor: 'white',
          border: `2px solid ${theme.colors.avani.magenta}`,
          color: theme.colors.avani.teal,
          paddingTop: '8px',
          borderRadius: '32px',
          [`&:hover`]: { border: `2px solid ${theme.colors.avani.magenta}`, color: theme.colors.avani.magenta }
        }}
      >
        {buttonLabel}
      </StyledButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
        onClose={() => setAnchorEl(null)}
      >
        <List>
          {!!barNames.length && (
            <>
              {barNames.length > 1 && (
                <StyledListItem
                  key={'all'}
                  value={'All'}
                  onClick={() => {
                    setBarName(undefined);
                    setButtonLabel('All Bars');
                    setAnchorEl(null);
                  }}
                >
                  <Typography sx={{ flexGrow: 1, pt: '3px' }}>All</Typography>
                </StyledListItem>
              )}
              {barNames.map((option, index) => {
                return (
                  <StyledListItem
                    key={index}
                    value={option}
                    onClick={() => {
                      setBarName(option);
                      setButtonLabel(option);
                      setAnchorEl(null);
                    }}
                  >
                    <Typography sx={{ flexGrow: 1, pt: '3px' }}>{option}</Typography>
                  </StyledListItem>
                );
              })}
            </>
          )}
        </List>
      </Popover>
    </>
  );
};
